import { memo, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlRoomListRequest } from "../../models/service-models/hotel/RoomListRequest";
import { DefinitionService } from "../../services/DefinitionService";

export type RoomSelectProps = {
    value?: string | string[];
    onChange?: Function;
    selectedHotel?: string;
    defaultValue?:  string | string[];
    excludedValue?: string;
    getAll?: boolean;
    mode?: 'multiple' | 'tags' | undefined;
}


export const RoomSelect = memo(function RoomSelect(props: RoomSelectProps) {
    const { t } = useTranslation();
    const [RoomListRequest, setRoomListRequest] = useState<mdlRoomListRequest>({ pageSize: 0 });

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data: data,
        isLoading: isLoading,
        refetch: refetch,
    } = useQuery(
        ["getRooms", props.selectedHotel],
        () => {
            if (props.selectedHotel || props.getAll)
                return DefinitionService.RoomList({ ...RoomListRequest });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.selectedHotel || !!props.getAll
        }
    );

    return (
        <>
            <Select
                loading={isLoading}
                mode={props.mode}
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                style={{ width: "100%" }}
                size="middle"
                defaultValue={props.defaultValue}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseRoom")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map((h:any) => Object.assign(h, {
                    label: h.name,
                    value: h.roomId
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
})